import { createAction } from '@reduxjs/toolkit';
import { SetFavoriteAction, RemoveFavoriteAction } from './types';

export const setFavorite = createAction<SetFavoriteAction>(
  'favorites/setFavorite'
);
export const removeFavorite = createAction<RemoveFavoriteAction>(
  'favorites/removeFavorite'
);
